<div class="pricing-container">
  <div class="price-line-item">
    <div class="glass-house-pricing-header pre-tax">
      <div>pre tax</div>
    </div>
    <div class="glass-house-price pre-tax">
      <app-column-primary-price
        [menu]="parentViewModel.cardStackMenu$ | push: 'immediate'"
        [section]="parentViewModel.cardStack$ | push: 'immediate'"
        [colVm]="columnViewModel"
        [rowVm]="parentViewModel.cardData$ | push: 'immediate'"
        [locConfig]="parentViewModel.locationConfig$ | push: 'immediate'"
        [locationId]="parentViewModel.locationId$ | push: 'immediate'"
        [productStylingVm]="parentViewModel"
        [ignoreStylingForSaleText]="true"
        [leadingTextOriginalPriceWithoutSale]="'$'"
        [leadingTextSalePrice]="'$'"
        [hidePreviousPrice]="true"
        [overridePriceStream]="Types.LocationPriceStream.Default"
        [finalPriceStringModifier]="removeDollarSign">
      </app-column-primary-price>
    </div>
  </div>
  <div class="price-line-item">
    <div class="glass-house-pricing-header">
      <div>out</div>
      <div>the door</div>
    </div>
    <div class="glass-house-price taxes-in">
      <app-column-primary-price
        [menu]="parentViewModel.cardStackMenu$ | push: 'immediate'"
        [section]="parentViewModel.cardStack$ | push: 'immediate'"
        [colVm]="columnViewModel"
        [rowVm]="parentViewModel.cardData$ | push: 'immediate'"
        [locConfig]="parentViewModel.locationConfig$ | push: 'immediate'"
        [locationId]="parentViewModel.locationId$ | push: 'immediate'"
        [productStylingVm]="parentViewModel"
        [hidePreviousPrice]="true"
        [leadingTextOriginalPriceWithoutSale]="'$'"
        [leadingTextSalePrice]="'$'"
        [overridePriceStream]="parentViewModel.priceStreamOverride$ | push: 'immediate'"
        [finalPriceStringModifier]="removeDollarSign">
      </app-column-primary-price>
    </div>
  </div>
</div>
